import i18next from "i18next"
import React from "react"
import { useTranslation } from "react-i18next"

import { SubscriptionMagazine } from "../SubscriptionMagazine/SubscriptionMagazine"

export const SubscriptionMagazinePress: React.FC = () => {
  const { t } = useTranslation()
  const currLang = i18next.language

  const categoriesList = [
    {
      id: "1",
      code: currLang === "ru" ? "press" : "press_en",
      name: t("SubscriptionMagazinePress.categoriesList.press"),
    },
  ]

  if (currLang === "ru") {
    categoriesList.push({
      id: "3",
      code: "News",
      name: t("SubscriptionMagazinePress.categoriesList.news"),
    })
  } else {
    categoriesList.push({
      id: "2",
      code: "IR",
      name: t("SubscriptionMagazinePress.categoriesList.ir-blog"),
    })
  }

  return (
    <SubscriptionMagazine
      categoriesList={categoriesList}
      returnValuesType="code"
      title={t("pressSubscription.Title")}
    />
  )
}
